import { render, staticRenderFns } from "./RefugiosMapa.vue?vue&type=template&id=54cd8f77&scoped=true&lang=pug&"
import script from "./RefugiosMapa.vue?vue&type=script&lang=js&"
export * from "./RefugiosMapa.vue?vue&type=script&lang=js&"
import style0 from "./RefugiosMapa.vue?vue&type=style&index=0&id=54cd8f77&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cd8f77",
  null
  
)

export default component.exports